import React, {Component} from 'react'
import { money, makeid } from '../../utils/helpers'
import { makeRequest } from "../../utils/Storefront.js"

class ProductTile extends Component {
  constructor(props) {
    super(props)
    const json = props.json
    let featuredImage = json.featuredImage
    let vOneImage = null
    // let hasFront = false
    for (let index = 0; index < json.images.edges.length; index++) {
      const image = json.images.edges[index].node
      const imageUrl = image.url;
      // if(imageUrl.includes('_F1.jpg')) {
      //   featuredImage = image
      //   hasFront = true
      // } else if(imageUrl.includes('_V1.jpg') || imageUrl.includes('_v1.jpg')) {
      //   vOneImage = image
      // }
      if(imageUrl.includes('_V1.jpg') || imageUrl.includes('_v1.jpg')) {
        vOneImage = image
      }
    }
    let secondImage = json.images?.edges[1]?.node || featuredImage
    // if (hasFront && vOneImage) {
    //   secondImage = vOneImage
    // }
    this.state = {
      data: json,
      lazyload: props.lazyload == 'true' ? true : false,
      look: props.look == 'true' ? true : false,
      tileKey: makeid(5),
      privatePrice: window.privateSaleEnabled ? parseFloat(JSON.parse(json.privatePrice?.value || '{}')[Shopify.currency.active] || 0) : 0,
      featuredImage: featuredImage,
      vOneImage: vOneImage || featuredImage,
      secondImage: secondImage,
      collectionLoaded: false,
      columnsDesktop: parseFloat(props.columnsDesktop || 4),
      columnsTablet: parseFloat(props.columnsTablet || 2),
      columnsMobile: parseFloat(props.columnsMobile || 2),
      desktopWidths: [[3200, 5400], [2480, 4200], [1920, 3100], [1440, 2400], [1280, 2000]],
      tabletWidths: [[1100, 1800], [1024, 1600], [900, 1400], [768, 1200]],
      mobileWidths: [[700, 1200], [600, 1100], [480, 1200], [400, 1000], [300, 800]],
      forloopIndex: parseInt(props.forloopIndex || 0),
      plpIndex: props.plpIndex,
    }

    this.swiperRef = React.createRef()
    this.learnqProduct(this.state.data)

  }

  learnqProduct(product) {
    window[`learnqProductItem_${product.id}`] = {
      Name: product.title,
      ProductID: product.id,
      Categories: product.categories,
      ImageURL: `https:${product.featured_image?.src}&width=600&height=600&crop=center`,
      URL: `${location.origin}${product.url}`,
      Brand: product.vendor,
      Price: money(product.selectedOrFirstAvailableVariant.price.amount),
      CompareAtPrice: product.selectedOrFirstAvailableVariant.compareAtPrice && parseFloat(product.selectedOrFirstAvailableVariant.compareAtPrice.amount) > parseFloat(product.selectedOrFirstAvailableVariant.price.amount) ? money(product.selectedOrFirstAvailableVariant.compareAtPrice.amount) : '$0',
    }
  }

  checkImageRender() {
    const nextCta = document.querySelector(`.plp-cta [data-cta-index="${this.state.plpIndex + 1}"]`)
    if(this.state.plpIndex == 1) {
      this.swiperRef.current.classList.remove('!opacity-0')
      const prevCta = document.querySelector(`.plp-cta [data-cta-index="${this.state.plpIndex}"]`)
      if(prevCta) prevCta.classList.remove('!opacity-0')
      if(nextCta) nextCta.classList.remove('!opacity-0')
    } else {
      const prevIndex = this.state.plpIndex - 1
      const preElement = document.querySelector(`[data-plp-index="${prevIndex}"] [data-product-card-swiper]`)
      const ctaElement = document.querySelector(`.plp-cta [data-cta-index="${this.state.plpIndex}"]`)
      if(preElement || ctaElement) {
        const timer = setInterval(() => {
          if(ctaElement) {
            if(!ctaElement.classList.contains('!opacity-0')) {
              clearInterval(timer)
              this.swiperRef.current.classList.remove('!opacity-0')
              if(nextCta) nextCta.classList.remove('!opacity-0')
            }
          } else {
            if(!preElement.classList.contains('!opacity-0')) {
              clearInterval(timer)
              this.swiperRef.current.classList.remove('!opacity-0')
              if(nextCta) nextCta.classList.remove('!opacity-0')
            }
          }
        }, 50)
      }
    }
  }

  imageUrl(url, width) {
    return url.replace('.jpg?', `.jpg?width=${width}&`)
      .replace('.png?', `.png?width=${width}&`)
      .replace('.webp?', `.webp?width=${width}&`)
  }

  getSizeOptions(product = this.state.data) {
    return product.options.filter(option => option.name == window.productStrings.size)[0]
  }
  getPicture(image, lazyload=true, classes='object-cover', checkOnload=false, customAlt='') {
    return <picture>
      {
        this.state.desktopWidths
          .map(
            (desktopWidth, index) => <source media={`(min-width:${desktopWidth[0]}px)`} srcSet={this.imageUrl(image.url, Math.round(desktopWidth[1] / this.state.columnsDesktop))} key={`desktop-${this.state.data.id}-${index}`} />
          )
      }
      {
        this.state.tabletWidths
          .map(
            (tabletWidth, index) => <source media={`(min-width:${tabletWidth[0]}px)`} srcSet={this.imageUrl(image.url, Math.round(tabletWidth[1] / this.state.columnsTablet))} key={`tablet-${this.state.data.id}-${index}`} />
          )
      }
      {
        this.state.mobileWidths
          .map(
            (mobileWidth, index) => <source media={`(min-width:${mobileWidth[0]}px)`} srcSet={this.imageUrl(image.url, Math.round(mobileWidth[1] / this.state.columnsMobile))} key={`mobile-${this.state.data.id}-${index}`} />
          )
      }
      <img src={this.imageUrl(image.url, Math.round(this.state.mobileWidths[this.state.mobileWidths.length - 1][1] / this.state.columnsMobile))}
        className={`${classes}`}
        fetchpriority={lazyload ? 'auto' : 'high'}
        loading={lazyload ? 'lazy' : 'eager'}
        alt={customAlt || image.altText}
        width={image.width}
        height={image.height}
        onLoad={(e) => {
          checkOnload ? this.checkImageRender() : null
        }}
        />
    </picture>
  }


  productId(id) {
    return id.replace('gid://shopify/Product/', '')
  }
  variantId(id) {
    return id.replace('gid://shopify/ProductVariant/', '')
  }

  productUrl(product=this.state.data) {
    const sizeOptions = this.getSizeOptions(product)

    return `${Shopify.routes.root}${!!window.collectionJson ? 'collections/' + window.collectionJson.handle + '/' : ''}products/${product.handle}${sizeOptions && sizeOptions.optionValues.length == 1 ? '?variant=' + this.variantId(product.selectedOrFirstAvailableVariant.id) : ''}`
  }

  initSlider() {
    new Swiper(this.swiperRef.current, {
      pagination: {
        el: '.swiper-pagination',
        type: 'progressbar',
      },
    })
  }

  componentDidMount() {
    this.initSlider()

    if(typeof this.state.collectionLoaded == 'undefined' || !this.state.collectionLoaded) {
      const query = `
        query @inContext(country: ${Shopify.country}, language: ${Shopify.locale.toUpperCase()}) {
          product(id: "${this.state.data.id}") {
            ${window.collectionsResponse}
          }
        }
      `
      makeRequest(
        (res) => {
          const collections = res?.data?.product?.collections?.edges
          this.setState({
            collectionLoaded: true,
            data: Object.assign(this.state.data,
              { collections, }
            ),
          })
          if(window[`learnqProductItem_${this.state.data.id}`]) window[`learnqProductItem_${this.state.data.id}`]['Categories'] = collections?.map(edge => edge.node.title)
        },
        query
      )
    }
  }

  handleGTMColorClick = (e, data) => {
    e.preventDefault();
    e.stopPropagation();

    Shopify.analytics.publish('gtm_select_color', {
      product_id: data.productId,
      variant_id: data.variantId,
      item_name: data.productName,
      color: data.colorName
    });
    window.location.href = data.url;
  }

  render() {
    return (
      <div className="product-card group"
        data-product-card
        data-sku={this.state.data.sku?.value}
        data-url={ this.productUrl() }
        data-tile-key={this.state.tileKey}
      >
        {
          this.state.vOneImage &&
          <a className='flex flex-col' href={ this.productUrl() }>
            <div className={`product-card--top ${this.state.look ? '!hidden' : ''} ${this.state.plpIndex ? '' : ''}`}
              data-product-card-swiper
              ref={this.swiperRef}
            >
              {/* this.state.plpIndex ? !opacity-0 transition-opacity ease-in-outt duration-300 */}
              <div className="product-card--loading">
                <span className="product-card--loading__dot"></span>
                <span className="product-card--loading__dot"></span>
                <span className="product-card--loading__dot"></span>
              </div>

              <div className="product-card--image__main swiper-wrapper z-1"
                // aria-label={`${this.state.data.title} - ${this.state.data.options[0]?.optionValues[0]?.name}`}
                // aria-labelledby={`product-tile-${this.state.tileKey}`}
                // style={{animationDelay: `${this.state.forloopIndex * 0.1}s`}}
              >
                <div className="swiper-slide relative pb-[133%] !h-auto">
                  { this.getPicture(this.state.vOneImage, false, 'product-card--image__first', true, `${ this.state.data.title } - Image - ${this.state.vOneImage.id}`) }
                </div>
                {
                  this.state.data.images?.edges?.map((edge, index) =>
                    edge.node.id == this.state.vOneImage?.id ? null :
                    <div className='swiper-slide relative pb-[133%] !h-auto !block lg:!hidden'
                      key={`product-image-${this.state.tileKey}-${this.state.data.id}-${index}`}
                    >
                      { this.getPicture(edge.node, true, 'product-card--image__first', false, `${ this.state.data.title } - Image - ${edge.node.id}`) }
                    </div>
                  )
                }
                {
                  this.state.data.images?.edges?.length == 1 &&
                  <div className='swiper-slide relative pb-[133%] !h-auto !block lg:!hidden'>
                    { this.getPicture(this.state.secondImage, true, 'product-card--image__first object-top') }
                  </div>
                }
              </div>
              <div className="swiper-pagination !block lg:!hidden !top-auto bottom-0 !h-0.75 !bg-accent-1 z-2"></div>

              <div className="product-card--hover absolute w-6 h-6 right-0 top-0 before:content-[''] before:w-6 before:h-6 before:border before:border-white before:absolute before:top-0 before:right-0 after:content-[''] after:absolute after:w-0 after:h-0 !hidden lg:!flex">
              </div>

              <div className="absolute top-3.5 left-3.5 text-white flex items-center gap-3 flex-wrap z-3 text-xs">
                { this.state.data.tags.includes('Coming Soon') && <span className="capitalize">{window.productStrings.badges.comingSoon}</span>}
                { Shopify.country == 'JP' && this.state.data.tags.includes('store-only') && <span className="capitalize">{window.productStrings.badges.exclusive}</span>}
                { ((this.state.data.comingSoonUS?.value == 'true' && Shopify.country == 'US') || this.state.data.comingSoonROW?.value == 'true' && Shopify.country != 'US') && <span className="capitalize">{window.productStrings.badges.comingSoon}</span>}
              </div>
            </div>

            <div className="product-card--title text-xs">
              <div id={`product-tile-${this.state.tileKey}`} className={`${this.state.look ? '!hidden' : ''}`}>
                <span className='visually-hidden'>Shop</span>
                { this.state.data.title }
                <span className='visually-hidden'>
                  &nbsp;-&nbsp;
                  {`${this.state.data.options.filter(option => option.name == window.productStrings.color)[0]?.optionValues[0]?.name} as a main color option`}
                </span>
              </div>
              <div className="text-nowrap">
                <span className={`${typeof window.privateSale != 'undefined' && window.privateSale && window.showForLoggedInUsers ? '!hidden' : ''} inline-flex items-center gap-3`} data-plp-regular-price>
                  {
                    !!this.state.data.selectedOrFirstAvailableVariant.compareAtPrice && parseFloat(this.state.data.selectedOrFirstAvailableVariant.compareAtPrice.amount) > parseFloat(this.state.data.selectedOrFirstAvailableVariant.price.amount) &&
                    <del className="text-fourth-grey">{ money(this.state.data.selectedOrFirstAvailableVariant.compareAtPrice.amount) }</del>
                  }
                  { money(this.state.data.selectedOrFirstAvailableVariant.price.amount) }
                </span>
                <span className={`${typeof window.privateSale != 'undefined' && window.privateSale && window.showForLoggedInUsers ? '' : '!hidden'} inline-flex items-center gap-3`} data-plp-private-price>
                  {
                    this.state.privatePrice > 0 && parseFloat(this.state.data.selectedOrFirstAvailableVariant.price.amount) > this.state.privatePrice &&
                    <>
                      <del className="text-fourth-grey">{ money(this.state.data.selectedOrFirstAvailableVariant.price.amount) }</del>
                        { money(this.state.privatePrice) }
                      <br />
                    </>
                  }
                  {
                    !(this.state.privatePrice > 0 && parseFloat(this.state.data.selectedOrFirstAvailableVariant.price.amount) > this.state.privatePrice) &&
                    <>
                      { money(this.state.data.selectedOrFirstAvailableVariant.price.amount) }
                    </>
                  }
                </span>
              </div>
            </div>
          </a>
        }

        <button aria-label="Add to Wishlist"
          data-with-epi="true"
          className={`plp-wishlist-btn !text-[0.625rem] lg:!text-xs !absolute !top-2 !right-4 lg:!top-3 lg:!right-10 !z-1 !text-white !text-xs !leading-[1.2] swym-button swym-add-to-wishlist-view-product product_${this.productId(this.state.data.id)} before:content-['${window.productStrings.save}'] after:!hidden !font-arial opacity-0 lg:opacity-0 lg:group-hover:opacity-100`}
          data-swaction="addToWishlist"
          data-product-id={ this.productId(this.state.data.id) }
          data-variant-id={ this.variantId(this.state.data.selectedOrFirstAvailableVariant.id) }
          data-product-url={`${location.origin}/products/${this.state.data.handle}`}
        ></button>
        <div className="grow flex flex-col justify-between">
          <div>
            {
              this.state.data.style && this.state.data.collections?.filter(c => c.node.title == this.state.data.style.value).map((collection, index) =>
                collection?.node?.products?.edges?.length > 1 ?
                <div className={`product-card--more flex items-center justify-between flex-wrap gap-2 ${this.state.look ? '!visible' : ''}`}
                  key={`more-color-${this.state.data.id}-${index}`}
                >
                  <span className="normal-case text-tb-black text-xs">
                    {
                      this.state.look ? `${window.productStrings.color}.` : window.productStrings.moreColors
                    }
                  </span>

                  <div className="inline-flex items-center gap-1">
                    {
                      collection?.node?.products.edges?.map((edge, index) =>
                        edge.node.availableForSale ?
                        (edge.node.id == this.state.data.id ?
                          <span className="w-4 h-4 block overflow-hidden border border-light-grey bg-contain bg-center"
                            key={`more-color-${this.state.data.id}-${index}`}
                            title={ edge.node.options.filter(option => option.name == window.productStrings.color)[0]?.optionValues[0]?.name }
                            style={ { backgroundImage: `url('https://${Shopify.cdnHost}/shop/files/${edge.node.ffid?.value}_cs.jpg?width=20'), url('https://${Shopify.cdnHost}/shop/files/${edge.node.sku?.value}_cs.jpg?width=20'), url('https://${Shopify.cdnHost}/shop/files/${edge.node.sku?.value}_cs.png?width=20')` }}
                          >
                          </span>:
                          <a className="aaaa w-4 h-4 block overflow-hidden border border-light-grey bg-contain bg-center"
                            key={`more-color-${this.state.data.id}-${index}`}
                            href={this.productUrl(edge.node)}
                            onClick={(e) => this.handleGTMColorClick(
                              e,
                              {
                                colorName: edge.node.options.filter(option => option.name == window.productStrings.color)[0]?.optionValues[0]?.name,
                                productId: this.productId(edge.node.id),
                                variantId: this.variantId(edge.node.selectedOrFirstAvailableVariant.id),
                                productName: edge.node.title,
                                url: this.productUrl(edge.node)
                              }
                            )}
                            aria-label={`Shop ${this.state.data.title} - ${edge.node.options.filter(option => option.name == window.productStrings.color)[0]?.optionValues[0]?.name} as a more color option`}
                            title={ edge.node.options.filter(option => option.name == window.productStrings.color)[0]?.optionValues[0]?.name }
                            style={ { backgroundImage: `url('https://${Shopify.cdnHost}/shop/files/${edge.node.ffid?.value}_cs.jpg?width=20'), url('https://${Shopify.cdnHost}/shop/files/${edge.node.sku?.value}_cs.jpg?width=20'), url('https://${Shopify.cdnHost}/shop/files/${edge.node.sku?.value}_cs.png?width=20')` }}
                            tabIndex={-1}
                          >
                          </a>
                        ): null
                      )
                    }
                  </div>
                </div> : null
              )
            }

            <div className='product-card--more h-4'>&nbsp;</div>
          </div>
          <div className={`product-card--quickadd items-center gap-x-2.5 gap-y-1 mt-4 flex-col lg:flex-row ${this.state.look ? '!block' : ''}`}
            style={{ display: 'none' }}
            data-product-quickadd
          >
            { !this.state.data.customCTA && this.getSizeOptions() && this.getSizeOptions()?.optionValues.length > 0 &&
              <>
                 {
                  this.state.look ? <div className='flex justify-between gap-4'>
                    <span className='w-[1.875rem]'>Size.</span>
                    <ul className="flex items-center justify-end gap-2 flex-wrap" data-quickadd-list>
                      {
                        this.state.data.variants.edges.map((edge, index) =>
                          <li className=""
                            key={`variant-${this.state.data.id}-${index}`}
                            style={{ order: parseInt(edge.node.selectedOptions.filter(option => option.name == window.productStrings.size)[0].value) * 2 }}
                          >
                            <button className={`px-2 h-7 border border-tb-black !border-solid hover:bg-button hover:text-white transition-all ease-in-out duration-200 ${edge.node.availableForSale ? '' : 'opacity-50'} ${ this.state.data.variants.edges.length == 1 ? 'bg-button text-white product-card--quickadd__active' : ''}`}
                              data-variant-id={ edge.node.id.replace('gid://shopify/ProductVariant/', '') }
                              data-size={ edge.node.selectedOptions.filter(option => option.name == window.productStrings.size)[0].value }
                              disabled={ !edge.node.availableForSale }
                            >
                              { edge.node.selectedOptions.filter(option => option.name == window.productStrings.size)[0].value }
                            </button>
                          </li>
                        )
                      }
                    </ul>
                  </div> :
                  <details className={`w-full lg:w-[7.375rem] relative ${ this.state.data.variants.edges.length == 1 ? 'hidden' : ''}`}>
                    <summary className="border border-fore cursor-pointer text-xs leading-4 group h-[2.8125rem] flex items-center gap-4 justify-between !h-9 px-2.5 border-box" data-product-quickadd-selected>
                      <div className="group-hover:underline">
                        { window.productStrings.selectSize }
                      </div>
                      <span className="summary-plus text-base leading-4">&plus;</span>
                      <span className="summary-minus">&ndash;</span>
                    </summary>
                    <ul className="absolute bottom-full left-0 -right-px bg-white border-x border-fore p-0 z-2" data-quickadd-list>
                      {
                        this.state.data.variants.edges.map((edge, index) =>
                          <li className="border-t border-fore box-border" key={`variant-${this.state.data.id}-${index}`}>
                            <button className={`w-full text-xs leading-4 p-2.5 hover:bg-button hover:text-white transition-all ease-in-out duration-200 flex items-center justify-between box-border ${edge.node.availableForSale ? '' : 'opacity-50'} ${ this.state.data.variants.edges.length == 1 ? 'product-card--quickadd__active' : ''}`}
                              data-variant-id={ edge.node.id.replace('gid://shopify/ProductVariant/', '') }
                              data-size={ edge.node.selectedOptions.filter(option => option.name == window.productStrings.size)[0].value }
                              disabled={ !edge.node.availableForSale }
                            >
                              { edge.node.selectedOptions.filter(option => option.name == window.productStrings.size)[0].value }
                              <span data-eu-size></span>
                            </button>
                          </li>
                        )
                      }
                    </ul>
                  </details>
                }
              </>
            }

            {
              this.state.data.customCTA ?
                <button className='button button--secondary w-full'>
                  {this.state.data.customCTA.value}
                </button>
                :
                <button
                  className={`${this.state.look ? 'underline text-sm mt-4 float-right' : 'button grow !h-9 w-full lg:w-auto'} `}
                  data-quickadd-cart
                  dangerouslySetInnerHTML={{ __html: this.state.data.availableForSale ? window.productStrings.addToBag : window.productStrings.soldOut }}
                />
            }
          </div>
        </div>
      </div>
    )
  }
}
export default ProductTile